import { Divider as MuiDivider, type DividerProps } from '@mui/material';

export function Divider(props: DividerProps) {
  const { sx, ...otherProps } = props;
  return <MuiDivider sx={{ borderColor: 'Black', mt: 4, mb: 4, ...sx }} {...otherProps} />;
}
